import React, { Component } from "react";
import Core from "Core";
import { observer } from "mobx-react";

export default observer(
  class Text extends Component {
    render() {
      let {
        className,
        label,
        model,
        dataMember,
        placeholder,
        readOnly,
        required
      } = this.props;

      let value = null;
      if (model && dataMember) {
        value = model[dataMember];
      }

      value = value || "";

      let validationState = null;

      if (required && value === "") {
        validationState = "error";
      }

      return (
        <Core.Components.FormGroups.LabelValuePair
          className={className}
          label={label}
          validationState={validationState}
        >
          <Core.Components.Inputs.Text
            model={model}
            dataMember={dataMember}
            placeholder={placeholder}
            readOnly={readOnly}
          />
          {this.props.children}
        </Core.Components.FormGroups.LabelValuePair>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Core/Components/FormGroups/Text.js